var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"splash-page"},[_c('img',{staticClass:"splash-img",attrs:{"src":require("@/assets/icons/splash.jpg"),"alt":"江苏智慧人社"}}),_vm._v(" "),_c('div',{staticClass:"skip-hit",on:{"click":_vm.enterApp}},[_vm._v("跳过")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638dd0fc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Splash.vue
// module id = null
// module chunks = 